import { Container, Header, Content } from 'rsuite';
import { Heading, Image, Text, useTheme, View, Authenticator } from '@aws-amplify/ui-react';

import banner_w from '../banner_w.png';
import banner from '../banner.png';
import { useAuthContext } from '../contexts/AuthContext';

const authComponents = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View
        backgroundColor={tokens.colors.white}
        textAlign="center"
        padding={tokens.space.medium}
        border="1px solid var(--amplify-components-authenticator-router-border-color)"
      >
        <Image src={banner} alt="Logo" />
      </View>
    );
  },
  Footer() {
    const { tokens } = useTheme();
    const year = new Date().getFullYear();
    return (
      <View
        backgroundColor={tokens.colors.black}
        textAlign="center"
        padding={tokens.space.medium}
        border="1px solid var(--amplify-components-authenticator-router-border-color)"
      >
        <Text color={tokens.colors.white} fontSize="0.7em">
          &copy; {year} Dontek Electronics Pty Ltd
        </Text>
      </View>
    );
  },
  ResetPassword: {
    Header() {
      return <Heading level={5}>Reset Password</Heading>;
    },
  },
};

export function AppShell({ content }) {
  const { loginId } = useAuthContext();
  return (
    <Authenticator components={authComponents} hideSignUp={true} variation="modal">
      {({ signOut }) => (
        <Container as="main" className="bg-neutral-100 p-2 sm:p-4">
          <Header style={{ padding: 0, height: 'auto' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: '#0f131a',
                height: 56,
                padding: '0 16px',
                boxSizing: 'border-box',
              }}
            >
              <img
                src={banner_w}
                alt="Dontek App logo"
                style={{ height: 26, width: 'auto', display: 'block', flexShrink: 0 }}
              />
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <span style={{ color: '#fff', fontSize: '0.85em' }}>Welcome: {loginId}</span>
                <button
                  type="button"
                  aria-label="Sign out"
                  onClick={signOut}
                  style={{
                    background: 'transparent',
                    color: '#fff',
                    border: '1px solid rgba(255,255,255,0.4)',
                    borderRadius: 6,
                    padding: '4px 10px',
                    fontSize: '0.85em',
                    cursor: 'pointer',
                  }}
                >
                  Sign Out
                </button>
              </div>
            </div>
          </Header>
          <Content
            style={{
              background: '#fff',
              border: '1px solid #e9ebed',
              borderTop: 'none',
              padding: 10,
            }}
          >
            {content}
          </Content>
        </Container>
      )}
    </Authenticator>
  );
}
